import { fetchFavoriteBrands } from '@common/Brands/helpers/favoriteBrand';
import { FAVORITES } from '../constants';

/**
 * Return favorite brands array
 *
 * @param {int} brandGroupId
 * @return {array}
 */

export const parseFavoriteBrands = async (availableBrands, gender) => {
    const result = [];

    if (typeof availableBrands !== 'undefined') {
        await fetchFavoriteBrands((response) => {
            const availableBrandsIds = availableBrands.map(item => item.value.split('-')[0]);
            const genderFavoriteBrands = response[gender];

            if (genderFavoriteBrands) {
                const favoriteBrands = genderFavoriteBrands
                    .map(item => item.id)
                    .filter(item => availableBrandsIds.some(el => (el === item)));

                result.push({
                    brandgroupId: FAVORITES,
                    brandIds: favoriteBrands
                });
            }
        });
    }

    return result;
};
